import { createContextFactory } from '@streem/toolbox';
export const [ReservationProvider, useReservation,] = createContextFactory('Reservation');
//# sourceMappingURL=reservation.js.map